module.exports = __webpack_public_path__ + "static/img/D03-盈丰小学.84ad7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/D03-盈丰小学.png
// module id = 7+VW
// module chunks = 0